module.exports = __webpack_public_path__ + "img/床垫枕头定制.d3aba75d.png";